// extracted by mini-css-extract-plugin
module.exports = {"lead":"lead-module--lead--r475W"};